const GATILHO_FORMULA = /^[=+\-@\t\r]/;

export const textoCsv = (campo: any) => {
  const valor = campo == null ? "" : String(campo);
  return GATILHO_FORMULA.test(valor) ? `'${valor}` : valor;
};

const celulaCsv = (campo: string) => `"${campo.replace(/"/g, '""')}"`;

export const montarCsv = (cabecalho: string[], linhas: string[][]) =>
  [cabecalho]
    .concat(linhas)
    .map((linha) => linha.map(celulaCsv).join(";"))
    .join("\r\n");

export const baixarCsv = (prefixoArquivo: string, conteudo: string) => {
  const blob = new Blob(["\ufeff" + conteudo], { type: "text/csv;charset=utf-8;" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${prefixoArquivo}_${new Date().getTime()}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
